export default __webpack_public_path__ + "static/media/13.7e6359ee.png";